let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fQ94l")).then(() => parcelRequire('doFig'));